export default __webpack_public_path__ + "static/media/ComingSoon.ece8c300.jpg";